import axios from "axios";
import {
  GET_ALL_DOGS,
  GET_ALL_TEMPS,
  GET_DOGS_BY_NAME,
  RESET_SHOW_DOGS,
  FILTER_DOGS,
  CHANGE_LENGUAGE,
} from "../action-types";

export const filterDogs = (filter) => {
  return { type: FILTER_DOGS, payload: filter };
};

export const resetShowDogs = () => {
  return { type: RESET_SHOW_DOGS };
};
export const changeLenguage = (lenguage) => {
  return { type: CHANGE_LENGUAGE, payload: lenguage };
};

export const getAllDogs = () => {
  return async (dispatch) => {
    try {
      const res = await axios.get("/dogs");
      return dispatch({ type: GET_ALL_DOGS, payload: res.data });
    } catch (error) {
      return dispatch({
        type: GET_ALL_DOGS,
        payload: new Error(),
      });
    }
  };
};

export const getAllTemps = () => {
  return async (dispatch) => {
    try {
      const res = await axios
        .get("/dogs/temps")
        .then((res) => res.data)
        .catch(() => {
          throw new Error();
        });
      return dispatch({ type: GET_ALL_TEMPS, payload: res });
    } catch (error) {
      return dispatch({
        type: GET_ALL_TEMPS,
        payload: new Error(),
      });
    }
  };
};

export const getDogByName = (name) => {
  return async (dispatch) => {
    try {
      const res = await axios.get(`/dogs?name=${name}`).then((res) => res.data);
      return dispatch({ type: GET_DOGS_BY_NAME, payload: res });
    } catch (error) {
      return dispatch({
        type: GET_DOGS_BY_NAME,
        payload: new Error(),
      });
    }
  };
};
